<template>
    <Transition name="fade">
        <div
            ref="Modal"
            v-if="showing"
            class="overflow-y-auto z-50 py-12 px-4 fixed inset-0 overflow-x-hidden bg-opacity-75 bg-blue-nav"
            @click.self="close"
            aria-modal="true"
            role="dialog"
            aria-label="pop-up"
        >
            <div class="flex item-center justify-center" @click.self="close">
                <div
                    class="relative w-full max-w-2xl bg-white shadow-lg rounded-lg pt-10 pb-4 px-2"
                >
                    <a
                        ref="closeButton"
                        aria-label="close"
                        class="absolute top-0 right-0 my-2 mx-2 no-underline text-grey-darker hover:text-dark-blue-400 text-2xl"
                        @click.prevent="close"
                    >
                        <font-awesome-icon :icon="['fa', 'times-circle']" />
                    </a>
                    <slot />
                </div>
            </div>
        </div>
    </Transition>
</template>

<script>
export default {
    props: {
        showing: {
            required: true,
            type: Boolean,
        },
    },
    methods: {
        close() {
            this.$emit("close");
        },
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: all 0.4s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
